import React from "react";
const MoreSvg = ({ color = "white", className, ...props }) => {
  return (
    <svg
      width="10"
      height="5"
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      calcMode={className}
      {...props}
    >
      <path
        d="M5 4.5L0.669873 1.38009e-07L9.33013 8.95112e-07L5 4.5Z"
        fill={color}
      />
    </svg>
  );
};

export default MoreSvg;
